/**
 * HTMLCanvasElement と CanvasRenderingContext2D を簡単に利用するためのクラス
 */
export class Sprite {
  public readonly canvas: HTMLCanvasElement;
  public readonly context: CanvasRenderingContext2D;

  public constructor(width: number, height: number) {
    this.canvas = document.createElement('canvas');
    this.canvas.width = width;
    this.canvas.height = height;

    const context = this.canvas.getContext('2d');

    if (!context) {
      throw new Error('CanvasRenderingContext2D is null');
    }

    this.context = context;
  }

  public get width() {
    return this.canvas.width;
  }

  public get height() {
    return this.canvas.height;
  }
}
